import { inject, Injectable } from '@angular/core';
import { AlertService } from '@ddv/common-components';
import { ApiExecutorService, ApiServices } from '@ddv/http';
import { DropdownOption } from '@hs/ui-core-common';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable()
export class AdditionalFiltersService {
    private readonly alertService = inject(AlertService);
    private readonly reverseProxyApiService = inject<ApiExecutorService>(ApiServices.reverseProxy);

    getAdditionalFilterOptions(clientCode: string, queryType: string, runtimeParam: string): Observable<DropdownOption[]> {
        return this.reverseProxyApiService
            .invokeServiceWithParams<{ choices: DropdownOption[], isPartial: boolean }>(clientCode, `options/${queryType}/fields/${runtimeParam}`)
            .pipe(
                map((response) => {
                    if (!response.choices.length) {
                        this.alertService.error(`Field ${runtimeParam} cannot be filtered. Please review the query configuration.`);
                    }
                    return response.choices;
                }),
                catchError(() => {
                    this.alertService.error(`Field ${runtimeParam} cannot be filtered. Please review the query configuration.`);
                    return of([]);
                }),
            );
    }
}
